// Simple mega menu - no product previews, just multi-column navigation
console.log('🚀 MEGA MENU SCRIPT STARTING TO LOAD...');

class MegaMenu {
  constructor() {
    console.log('MegaMenu initialized - simplified version');
    this.init();
  }

  init() {
    // Simple initialization - just log that the mega menu is ready
    const megaMenus = document.querySelectorAll('.mega-menu');
    console.log(`Found ${megaMenus.length} mega menu(s) - ready for navigation`);
  }

}

console.log('Mega menu script loaded!');

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, looking for mega menu...');
  const megaMenuElement = document.querySelector('.mega-menu');
  console.log('Mega menu element found:', !!megaMenuElement);
  
  if (megaMenuElement) {
    console.log('Initializing MegaMenu...');
    new MegaMenu();
  } else {
    console.log('No .mega-menu element found');
  }
});

// Also initialize if called after DOM load (for theme editor)
if (document.readyState === 'loading') {
  console.log('Document still loading, waiting for DOMContentLoaded...');
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded fired, looking for mega menu...');
    const megaMenuElement = document.querySelector('.mega-menu');
    console.log('Mega menu element found:', !!megaMenuElement);
    
    if (megaMenuElement) {
      console.log('Initializing MegaMenu...');
      new MegaMenu();
    } else {
      console.log('No .mega-menu element found');
    }
  });
} else {
  console.log('Document already loaded, checking for mega menu immediately...');
  const megaMenuElement = document.querySelector('.mega-menu');
  console.log('Mega menu element found:', !!megaMenuElement);
  
  if (megaMenuElement) {
    console.log('Initializing MegaMenu...');
    new MegaMenu();
  } else {
    console.log('No .mega-menu element found');
  }
}